import React from "react";
import { View, ScrollView, Text, StyleSheet, Platform } from "react-native";

import appStyles from "../../../../appStyles";
import fontStyles from "../../../../fonts";
import AppTheme from "../../../AppTheme";
import ImageComponent from "../../../common/ImageComponent";
import {isNativeApp, isWeb} from "../../../../../helpers/utils";

export default function CalendarSignIn({
  connect = () => {},
}) {
  return (
    <>
      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <View
          style={{
            alignItems: "center",
            marginTop: isWeb ? 46 : 10,
            marginBottom: isWeb ? 58 : 14,
          }}
        >
          <ImageComponent
            image={require("../../../../../assets/onboarding-info/MariGlobeRight.png")}
            styles={[styles.image, { maxWidth: 270, overflow: "visible" }]}
          />
        </View>

        <Text style={[fontStyles.h15, styles.infoText]}>
            {isNativeApp() ? "Please sign in with your browser" : "Please sign in the popup window"}
        </Text>
        <Text
          style={[
            fontStyles.h3,
            styles.center,
            { marginTop: 81, marginBottom: 10, color: "#8B92A1" },
          ]}
        >
          Don't see a login page?
        </Text>
        <Text
          style={[
            fontStyles.h3,
            styles.center,
            { color: AppTheme.DEFAULT_COLOR },
          ]}
          onPress={connect}
        >
          Click here
        </Text>
      </ScrollView>
    </>
  );
}

const styles = StyleSheet.create({
  infoText: {
    marginTop: 58,
    paddingHorizontal: 24,
    textAlign: "center",
  },
  center: {
    textAlign: "center",
  },
});
